import React, { useState, useEffect } from 'react';
import { User, Palette, LogOut } from 'lucide-react';
import { SidebarTrigger } from './ui/sidebar';

// Header with optional sidebar trigger, date control, and user avatar dropdown
const DashboardHeader = ({
  title = 'Dashboard',
  subtitle,
  selectedDate,
  onDateChange,
  user,
  isDark,
  onToggleTheme,
  onLogout,
  showSidebarTrigger = true,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onDoc = (e) => {
      if (open && !e.target.closest?.('#dh-user-menu')) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const avatarLetter = (user?.name || user?.email || 'U').toString().trim().charAt(0).toUpperCase();

  return (
    <div className="bg-white border-b border-gray-200 px-3 sm:px-6 py-3 sm:py-4">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-start gap-2 sm:gap-3 min-w-0 flex-1">
          {showSidebarTrigger && (
            <div className="pt-0.5 sm:pt-1 flex-shrink-0"><SidebarTrigger /></div>
          )}
          <div className="min-w-0">
            <h1 className="text-lg sm:text-2xl font-bold text-gray-900 truncate">{title}</h1>
            {subtitle && <p className="text-gray-600 text-xs sm:text-base mt-0.5 sm:mt-1 line-clamp-1">{subtitle}</p>}
          </div>
        </div>
        <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
          {typeof selectedDate === 'string' && typeof onDateChange === 'function' && (
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => onDateChange(e.target.value)}
              className="block rounded-md border-gray-300 bg-white shadow-sm focus:border-indigo-500 focus:ring-indigo-500 text-xs sm:text-sm px-2 sm:px-3 py-1 w-28 sm:w-auto"
            />
          )}
          <div id="dh-user-menu" className="relative">
            <button
              onClick={() => setOpen((v) => !v)}
              className="flex h-9 w-9 items-center justify-center rounded-full bg-indigo-600 text-white text-sm font-medium"
              title={user?.email || user?.name || 'User'}
            >
              {avatarLetter}
            </button>
            {open && (
              <div className="absolute right-0 top-full mt-2 w-56 rounded-md border bg-white p-1 shadow-lg z-50">
                <div className="px-2 py-1.5 text-sm text-gray-900 border-b">
                  <p className="font-medium">{user?.name || 'User'}</p>
                  <p className="text-xs text-gray-500">{user?.email}</p>
                </div>
                {typeof onToggleTheme === 'function' && (
                  <button
                    onClick={() => { onToggleTheme(); setOpen(false); }}
                    className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm hover:bg-gray-100"
                  >
                    <Palette className="h-4 w-4" />
                    {isDark ? 'Light Mode' : 'Dark Mode'}
                  </button>
                )}
                {typeof onLogout === 'function' && (
                  <button
                    onClick={() => { setOpen(false); onLogout(); }}
                    className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm text-red-600 hover:bg-red-50"
                  >
                    <LogOut className="h-4 w-4" />
                    Log out
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
